/*
 * @Descripttion:
 * @Author: xiang.gao xiang.gao@travel-easy.com
 * @Date: 2022-08-19 15:44:23
 * @LastEditors: xiang.gao xiang.gao@travel-easy.com
 * @LastEditTime: 2022-08-25 15:17:40
 */
import ApiService from "@/core/services/ApiService";
import Config from "@/core/config/ApiConfig";

export default {
  getCustomDeclarationImportList(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/tms/custom-declaration-import/index",
      params
    );
  },
  addCustomDeclarationImport(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/tms/custom-declaration-import/store",
      params
    );
  },
  showCustomDeclarationImport(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/tms/custom-declaration-import/show",
      params
    );
  },
  updateCustomDeclarationImport(params) {
    return ApiService.post(
      Config.fulfillmentApiUrl + "/api/tms/custom-declaration-import/update",
      params
    );
  },
};
